/* eslint-disable camelcase */
/**
 * Divers
 */
;(function($) {
  var body = $('body')
  /** Update Collections button */
  if (body.hasClass('wp-admin')) {
    // Update Products custom order field via button on taxonomies table
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajaxurl,
      data: {
        action: 'update_collections',
      },
    })
  }
  // Toggle share in product page
  $('#share-toggle').on('click', function(e) {
    e.preventDefault()
    var panel = $('.share__panel')
    $(this).attr('aria-expanded', 'true')
    panel.addClass('visible')
    panel.attr('aria-expanded', 'true')
    panel.attr('aria-hidden', 'false')
  })
  // Toggle filters in shop page
  $('#filters-toggle').on('click', function(e) {
    e.preventDefault()
    var toggle = $(this)
    var toggleText = toggle.text() !== 'Close' ? 'Close' : 'Filter'
    toggle.text(toggleText)
    var panel = $('.filters-panel')
    var expandend = panel.attr('aria-expanded') !== 'true' ? 'true' : 'false'
    var hidden = panel.attr('aria-hidden') !== 'true' ? 'true' : 'false'
    panel.toggleClass('hide')
    $(this).attr('aria-expanded', expandend)
    panel.attr('aria-expanded', expandend)
    panel.attr('aria-hidden', hidden)
  })
  // Shop page anchor
  var hash = window.location.hash
  if (hash !== '') {
    var scrollH = $(hash).position().top - 75
    console.log(scrollH)
    // body.scrollTop(scrollH)
    $('html, body').animate(
      {
        scrollTop: scrollH,
      },
      100
    )
  }
  // video url
  function testUrlForMedia(pastedData, cc) {
    var success = false
    if (pastedData.match('://(www.)?youtube|youtu.be')) {
      let youtube_id
      if (pastedData.match('embed')) {
        youtube_id = pastedData.split(/embed\//)[1].split('"')[0]
      } else {
        youtube_id = pastedData.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0]
      }
      var v_id = youtube_id
      var i_src =
        'https://www.youtube-nocookie.com/embed/' +
        v_id +
        '?controls=' +
        cc +
        '&color=white&showinfo=0&autoplay=1&mute=1&loop=1&playlist=' +
        v_id +
        '&hd=1&fs=1&rel=0'
      success = true
    } else if (pastedData.match('://(player.)?vimeo.com')) {
      var vimeo_Reg = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/
      var match = pastedData.match(vimeo_Reg)
      v_id = match[3]
      i_src =
        'https://player.vimeo.com/video/' + v_id + '?title=0&byline=0&sidedock=0&portrait=0&color=ffffff&autoplay=1'
      success = true
    }
    if (success) {
      return i_src
    }
  }
  $('#screen a.embedvideo').bind('click', function(e) {
    e.preventDefault()
    $('#screen').css({ opacity: 0 })
    var ih = parseInt($('#screen').width() / 1.77777)
    var url = $(this).attr('href')
    var bkg = $(this).attr('data-bkg')
    var i_src = testUrlForMedia(url, 0) + '&background=' + bkg
    $('#screen')
      .empty()
      .append(
        '<iframe width="100%" height="' +
          ih +
          '" src="' +
          i_src +
          '" frameborder="0" webkitAllowFullScreen allowFullScreen></iframe>'
      )
    setTimeout(function() {
      $('#screen').css({ opacity: 1 })
    }, 1200)
  })
  $('#screen a.embedvideo').trigger('click')
  $('#filters-reset').on('click', function(e) {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    FWP.reset()
  })
  /**
   * Facet WP, scroll top on page change
   */
  $(document).on('facetwp-loaded', function() {
    // eslint-disable-next-line no-undef
    if (FWP.loaded) {
      $('html, body').animate(
        {
          // scrollTop: $('.facetwp-template').offset().top-230
          scrollTop: $('body'),
        },
        500
      )
    }
  })
})(jQuery)
